import React from "react";
import { IAcademicsMppBackgroundData } from "../../exports/interfaces";

const GraduateIntro = ({
  academicsMppBackground,
}: {
  academicsMppBackground: IAcademicsMppBackgroundData[];
}) => {
  return (
    <section>
      <div className="td_height_120 td_height_lg_40" />
      <div className="container">
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          <p
            className="td_section_subtitle_up td_fs_18 td_spacing_1 td_mb_10 td_accent_color"
            style={{ textAlign: "unset" }}
          >
            Policy Education for Competence and Relevance
          </p>
          <h2 className="td_section_title td_fs_48">
            Master of Public Policy (MPP)
          </h2>
          <p
            className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color"
            style={{ textAlign: "unset" }}
          >
            GRADUATE PROGRAM
          </p>
          <div className="td_height_30 td_height_lg_30" />
        </div>
        <div className="td_fs_18 custom-text-p">
          <h5>Background</h5>
          <p
            dangerouslySetInnerHTML={{
              __html: academicsMppBackground[0]?.description,
            }}
          />
        </div>
      </div>
      <div className="td_height_120 td_height_lg_60" />
    </section>
  );
};

export default GraduateIntro;
